import React, { useEffect, useState } from "react";
import Background from "../assets/images/bg/banner.jpg";
import logo from "../assets/images/logo/westbridge_logo-light.png";
import axios from "axios";

export default function Footer() {
  const [dataDesc, setData] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    setIsVisible(window.pageYOffset > 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getAllCMSMaster`
      );
      const data = res.data.filter(
        (entry) => entry.Title === "Footer AboutUs"
      );
      setData(data[0]?.Description || "");
    };
    fetchData();
  }, []);

  const truncateHTMLText = (html, wordLimit = 35) => {
    if (!html) return "";
    const text = html.replace(/<[^>]*>/g, "");
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <footer
      className="space-pt footer-section bg-overlay-black-90 bg-holder footer"
      style={{ backgroundImage: `url(${Background})` }}
    >
      <div className="container" style={{ marginRight: "17px" }}>
        <div className="row pb-lg-5">
          <div className="col-sm-6 col-lg-4 mb-4 mb-lg-0 pr-lg-5">
            <a href="/">
              <img
                className="img-fluid mb-3 footer-logo"
                src={logo}
                alt=""
              />
            </a>

            <p className="text-white" style={{ textAlign: "justify" }}>
              {truncateHTMLText(dataDesc, 35)}
            </p>

            <h5 className="text-white footer-title mb-2 mb-sm-4">
              Follow Us
            </h5>

            <div className="social-icon social-icon-style-02">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/millenniumworldschoolludhiana"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/millenniumworldschoolludhiana/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* USEFUL LINKS */}
          <div className="col-sm-6 col-lg-2 mb-4 mb-lg-0">
            <h5 className="text-white footer-title mb-2 mb-sm-4">
              Useful Link
            </h5>
            <div className="footer-link">
              <ul className="list-unstyled mb-0">
                <li><a className="text-white" href="/">Home</a></li>
                <li><a className="text-white" href="/admission-procedure">Admission Procedure</a></li>
                <li><a className="text-white" href="/careers">Careers</a></li>
                <li><a className="text-white" href="/contactus">Contact Us</a></li>
                <li><a className="text-white" href="/awards">Awards</a></li>
                <li><a className="text-white" href="/news-and-events">News & Events</a></li>
                <li><a className="text-white" href="/contactus">Enquiry</a></li>
              </ul>
            </div>
          </div>

          {/* ABOUT SCHOOL */}
          <div className="col-sm-6 col-lg-2 mb-4 mb-lg-0">
            <h5 className="text-white footer-title mb-2 mb-sm-4">
              About the School
            </h5>
            <div className="footer-link">
              <ul className="list-unstyled mb-0">
                <li><a className="text-white" href="/overview">Overview</a></li>
                <li><a className="text-white" href="/vision-values">Vision & Values</a></li>
                <li><a className="text-white" href="/research-development">Research & Development</a></li>
                <li><a className="text-white" href="/faqs">FAQ's</a></li>
              </ul>
            </div>

            <h5 className="text-white footer-title mt-3 mb-2 mb-sm-3">
              School Life
            </h5>
            <div className="footer-link">
              <ul className="list-unstyled mb-0">
                <li><a className="text-white" href="/music-and-dance">Music and Dance</a></li>
                <li><a className="text-white" href="/sports">Sports</a></li>
                <li><a className="text-white" href="/clubs-and-house-council">Clubs and House council</a></li>
                <li><a className="text-white" href="/creative-arts">Creative Arts</a></li>
              </ul>
            </div>
          </div>

          {/* PARENTS */}
          <div className="col-sm-6 col-lg-4 mb-4 mb-lg-0">
            <h5 className="text-white footer-title mb-2 mb-sm-4">
              Parents' Corner
            </h5>
            <div className="footer-link">
              <ul className="list-unstyled mb-0">
                <li><a className="text-white" href="/parents-speak">Parents' Speak</a></li>
                <li><a className="text-white" href="/parent-school-association">Parent School Association</a></li>
                <li><a className="text-white" href="/parents-as-partners">Parents as Partners</a></li>
              </ul>
            </div>

            <h5 className="text-white footer-title mt-3 mb-2 mb-sm-3">
              Scholastics
            </h5>
            <div className="footer-link">
              <ul className="list-unstyled mb-0">
                <li><a className="text-white" href="/cbse-board-affiliation">CBSE - Board Of Affiliation</a></li>
                <li><a className="text-white" href="/millennium-learning-system">The Millennium Learning System</a></li>
                <li><a className="text-white" href="/facilitators-development">Facilitators Development</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom bg-dark py-2">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <p className="mb-1 text-white" style={{ fontSize: "14px", fontWeight: "500" }}>
                This school is owned and managed by Maharaja Ranjit Singh Education Trust.
              </p>
              <p className="mb-0 text-white">
                © Copyright {new Date().getFullYear()} <a href="#">Millennium Westbridge School</a> All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
